import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function ListCheckMark({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        fillRule="evenodd"
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM10.9702 15.4702L16.9702 9.47024L16.0298 8.52979L10.5 14.0596L7.47024 11.0298L6.52979 11.9702L10.0298 15.4702C10.2895 15.7299 10.7105 15.7299 10.9702 15.4702Z"
        fill={iconColor}
      />
    </Svg>
  );
}
